<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col md="12" class="text-center py-3 border-bottom">
          <img src="@/assets/images/rush-logo-new.svg" alt="RUSH" class="img-fluid img-logo">
        </b-col>
      </b-row>
    </b-container>
    <b-container class="py-5">
      <b-row class="align-items-center">
        <b-col class="mb-4 mb-lg-0">
          <div>
            <h1 class="mt-3 mb-3">Yay! You are almost there!</h1>
            <p class="mb-5">Hey you! Please check your email! We’ve sent a confirmation link to <strong>{{ confirmedEmail }}</strong> so you can activate your account. If you don’t see an email from us, a few things could have happened:</p>
            <ul class="list-unstyled mb-4">
              <li>
                <div class="d-flex pr-md-5">
                  <div class="mr-3">
                    <b-img src="@/assets/images/authentication/success/circle.svg" alt="Bullet Point"></b-img>
                  </div>
                  <div>
                    <p>The email might be in your spam folder.</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="d-flex pr-md-5">
                  <div class="mr-3">
                    <b-img src="@/assets/images/authentication/success/circle.svg" alt="Bullet Point"></b-img>
                  </div>
                  <div>
                    <p>The email address you entered had a typo.</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="d-flex pr-md-5">
                  <div class="mr-3">
                    <b-img src="@/assets/images/authentication/success/circle.svg" alt="Bullet Point"></b-img>
                  </div>
                  <div>
                    <p>You mistakenly provided us with a different email address.</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="d-flex pr-md-5">
                  <div class="mr-3">
                    <b-img src="@/assets/images/authentication/success/circle.svg" alt="Bullet Point"></b-img>
                  </div>
                  <div>
                    <p>We can’t deliver the email to this address, normally due to corporate firewalls or filtering.</p>
                  </div>
                </div>
              </li>
            </ul>
            <b-button tag="a" href="https://www.rush.ph/" variant="primary" pill class="text-white py-3 px-4">
              Go back to homepage
            </b-button>
          </div>
        </b-col>
        <b-col lg="7">
          <b-img src="@/assets/images/success.svg" fluid alt="Success" class="d-block mx-auto mt-sm-3"></b-img>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("auth", ["loading", "confirmedEmail"])
  },
  created() {
    if (!this.confirmedEmail) 
      this.$router.push({name: "Home"});
    else {
      this.$gtag.event("success_page_load", {
        event_category: "Success",
        event_label: "Success Page Load",
      });
      window.fbq("trackCustom", "Load Success Page");
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./../../assets/styles/views/authentication/success.scss";
</style>